import { Disclosure } from "@headlessui/react";
import { FAQSectionTitle } from "./components/faq-section-title";
import { FAQButton } from "./components/faq-button";
import { FAQItem } from "./components/faq-item";
import { Text } from "../../components/text";
import { FAQItemList } from "./components/faq-item-list";

export const FAQPaymentAndRefund = () => {
  return (
    <>
      <FAQSectionTitle>
        Pembayaran dan Pengembalian Dana
      </FAQSectionTitle>

      <Disclosure>
        <FAQButton>
          Bagaimana cara pembayaran pesanan saya?
        </FAQButton>
        <FAQItem>
          <Text>
            Pembayaran dapat dilakukan melalui payment gateway OY! yang tersedia pada aplikasi Jooalan. Terdapat metode pembayaran melalui transfer Bank, virtual account, dompet digital dan QRIS
          </Text>
        </FAQItem>
      </Disclosure>
      <Disclosure>
        <FAQButton>
          Mengapa saya dikenakan biaya layanan pembayaran?
        </FAQButton>
        <FAQItem>
          <Text>
            Biaya layanan akan ditambahkan saat memilih metode pembayaran dan biaya layanan berbeda-beda tergantung metode pembayaran yang dipilih.
          </Text>
        </FAQItem>
      </Disclosure>
      <Disclosure>
        <FAQButton>
          Bagaimana dengan dana saya jika saya menerima kerusakan barang atau pembatalan pesanan?
        </FAQButton>
        <FAQItem>
          <Text>
            Jika terjadi kerusakan barang atau pembatalan pesanan, maka Anda berhak mendapat pengembalian dana dengan rincian:
          </Text>
          <FAQItemList
            numbered
            data={[
              'Pesanan sudah dikirim dan diterima >> harga barang dikurangi potongan dari voucher',
              'Pesanan sedang dikemas >> harga barang & ongkos kirim dikurangi potongan dari voucher',
              'Biaya layanan tidak akan dikembalikan jika terjadi pembatalan pesanan',
            ]}
          />
          <Text>
            Untuk melakukan pengembalian dana silahkan hubungi CS Jooalan: <b>0819-10000-118</b>
          </Text>
        </FAQItem>
      </Disclosure>
    </>
  )
}